import React from 'react';
import PropTypes from 'prop-types';
import RangeDateInput from '../../../core/form/RangeDateInput';
import Column from '../../../core/layout/Column';
import Row from '../../../core/layout/Row';
import Button from '../../../core/form/Button';
import { get } from 'lodash';

export default function PlacementTestItemsListFilter(props) {
  return (
    <Row>
      <Column size={3.5}>
        <RangeDateInput
          required
          label="Report Period"
          disabled={false}
          onChange={(dates) => {
            props.onChange('from', dates[0]);
            props.onChange('to', dates[1]);
          }}
          errorText={get(props.errors, 'from', '') || get(props.errors, 'to', '')}
          placeholder={['From', 'To']}
          value={[get(props.values, 'from', undefined), get(props.values, 'to', undefined)]}
        />
      </Column>
      <Column size={2}>
        <div style={{ marginTop: '43px' }}>
          <Button label="Search" icon="search" onClick={props.onSearch} />
        </div>
      </Column>
    </Row>
  );
}

PlacementTestItemsListFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  values: PropTypes.object,
};

PlacementTestItemsListFilter.defaultProps = {
  values: {},
};
